import React from "react";

const SignupPageLayout = ({ formSectionContent, featuresSectionContent }) => {
    return (
        <div
            id="signup"
            className="container row signup-form-container signup-page-layout"
        >
            <section className="signup-styles padded-column columns five">
                <h2 className="font-xlarge margin-b-l weight-medium">
                    Create a Free Account
                </h2>
                {formSectionContent}
            </section>
            <section className="columns five offset-two">
                {featuresSectionContent}
            </section>
        </div>
    );
};

export default SignupPageLayout;
